module.exports = __webpack_public_path__ + "img/video_play.ac956501.svg";